<template>

    <div class="no-mailbox-selected">

        <div class="lottie-container">

            <LottieSelectMailbox class="lottie-clean" :loop="true" :autoplay="true"></LottieSelectMailbox>

        </div>

        <p>{{$t('select_mailbox')}}</p>

    </div>

</template>

<script>
import LottieSelectMailbox from '../lottie/LottieSelectMailbox'

export default {

    name: 'no-mailbox-selected',

    components: {LottieSelectMailbox}

}
</script>

<style lang="scss" scoped>

.no-mailbox-selected {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .lottie-container {
        width: 96px;
        height: 96px;
        background-color: $forest;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    p {
        padding: 0 16px;
        margin-top: 16px;
        font-size: 17px;
        font-weight: 500;
        line-height: 24px;
        text-align: center;
    }

}

</style>
